<template>
  <div class="search-form">
    <!-- <b-row align-h="between">
      <b-col cols="9">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model="form.keyword"
              :placeholder="'规格编号/识别编号/识别名称 搜索...'"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              v-show="!disabled"
              variant="outline-success"
              @click="
                $emit('openEditFormDialog', {
                  type: 'add',
                })
              "
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>{{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row> -->
    <b-button
      size="sm"
      v-show="!disabled"
      variant="outline-success"
      @click="
        $emit('openEditFormDialog', {
          type: 'add',
        })
      "
      v-if="allow('A')"
    >
      <b-icon-plus></b-icon-plus>{{ $l('INDEX.btn_add') || '新增' }}
    </b-button>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
}

export default {
  props: {
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
